import { home } from './home'
import { rule } from './rule'
import { past2019 } from './past2019'
import { past2020 } from './past2020'
import { past2021 } from './past2021'
import { support } from './support'
import { ai } from './ai'

export {
  home,
  rule,
  past2019,
  past2020,
  past2021,
  support,
  ai
}
